import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { createPopper } from "@popperjs/core";
import { styled, TableCell, tableCellClasses, TableRow } from "@mui/material";

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#fafaff"
  },
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#E6E9F4",
    color: theme.palette.common.black,
    fontWeight: "600",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    color: theme.palette.text.primary,
  },
}));

const CustomTableRow = ({
  columns,
  onClick,
  onMouseLeaveAction,
  onMouseEnterAction,
}) => {
  const [mouseOver, setMouseOver] = useState(false);

  const handleOnMouseEnter = () => {
    setMouseOver(true);
  };
  const handleOnMouseLeave = () => {
    setMouseOver(false);
  };

  const [tooltipShow, setTooltipShow] = useState(false);
  const btnRef = useRef();
  const tooltipRef = useRef();

  const openTooltip = () => {
    createPopper(btnRef.current, tooltipRef.current, {
      placement: "right",
    });
    setTooltipShow(true);
  };
  const closeTooltip = () => {
    setTooltipShow(false);
  };

  return (
    <StyledTableRow
      onMouseEnter={() => {
        if (onMouseEnterAction) {
          onMouseEnterAction();
        }
        handleOnMouseEnter();
      }}
      onMouseLeave={() => {
        if (onMouseLeaveAction) {
          onMouseLeaveAction();
        }
        handleOnMouseLeave();
      }}
      className={`w-full ${
        onClick && "cursor-pointer"
      }`}
      onClick={onClick}
    >
      {columns.map(
        (
          {
            text,
            preActions,
            actions,
            textHref,
            hrefTarget,
            onTextClick,
            center,
            textMono,
            verticalAlign,
            right,
            renderToolTip,
            tooltipText,
          },
          i
        ) => {
          return (
            <StyledTableCell
              key={i}
              className={`px-3 py-3 ${
                mouseOver && typeof onTextClick === "function"
                  ? "underline cursor-pointer text-[#5568FE] "
                  : "no-underline"
              }  `}
            >
              <div
                className={
                  center
                    ? "flex justify-start items-center ml-4"
                    : right
                    ? "flex justify-end items-end"
                    : "flex justify-start items-center"
                }
              >
                {preActions?.length > 0 ? (
                  <div
                    className={`flex items-center ${
                      typeof text === "string" ? "mr-3" : ""
                    } justify-start `}
                  >
                    {preActions.map((Action, i) => (
                      <div
                        className={`flex flex-col items-center ${
                          i === 0 ? "" : "ml-2"
                        }`}
                        key={i}
                      >
                        <Action />
                      </div>
                    ))}
                  </div>
                ) : null}
                {typeof text === "string" ? (
                  textHref ? (
                    <Link href={textHref} passHref>
                      <a
                        target={hrefTarget}
                        className={`${
                          mouseOver
                            ? "underline cursor-pointer text-[#5568FE]"
                            : "no-underline"
                        } font-light text-sm`}
                      >
                        {text}
                      </a>
                    </Link>
                  ) : (
                    <div className="flex items-center justify-center ">
                      {verticalAlign ? (
                        <p className="text-sm font-normal dark:text-white text-black text-center font-mono">
                          <span className="text-center align-middle">
                            {text}
                          </span>
                        </p>
                      ) : renderToolTip ? (
                        <div
                          ref={btnRef}
                          onMouseEnter={openTooltip}
                          onMouseLeave={closeTooltip}
                        >
                          <p
                            onClick={onTextClick}
                            className={`${
                              mouseOver && typeof onTextClick === "function"
                                ? "underline cursor-pointer text-[#5568FE]"
                                : "no-underline"
                            } ${
                              textMono
                                ? "font-mono text-xs"
                                : "font-light text-sm"
                            }  `}
                          >
                            {text}
                          </p>
                          <div
                            className={`${
                              tooltipShow ? "" : "hidden"
                            } overflow-hidden flex items-center justify-center `}
                            ref={tooltipRef}
                          >
                            <div className="w-2  overflow-hidden inline-block">
                              <div className=" h-3 bg-gray-900  dark:bg-gray-900 -rotate-45  transform origin-top-right"></div>
                            </div>
                            <div
                              className={
                                "rounded-md p-2 bg-gray-900 dark:bg-gray-900"
                              }
                            >
                              <p className="text-xs text-gray-800 dark:text-gray-200">
                                {tooltipText}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <p
                          onClick={onTextClick}
                          className={`${
                            mouseOver && typeof onTextClick === "function"
                              ? "underline cursor-pointer text-[#5568FE]"
                              : "no-underline"
                          } ${
                            textMono
                              ? "font-mono text-xs"
                              : "font-light text-sm"
                          }  `}
                        >
                          {text}
                        </p>
                      )}
                    </div>
                  )
                ) : null}
                {actions?.length > 0 ? (
                  <div
                    className={`flex items-center ${
                      typeof text === "string" ? "ml-3" : ""
                    } justify-start`}
                  >
                    {actions.map((Action, i) => (
                      <div
                        className={`flex flex-col items-center ${
                          i === 0 ? "" : "ml-2"
                        }`}
                        key={i}
                      >
                        <Action />
                      </div>
                    ))}
                  </div>
                ) : null}
              </div>
            </StyledTableCell>
          );
        }
      )}
    </StyledTableRow>
  );
};

export default CustomTableRow;
